/**
 * @alias Plastic.User
 */
var User = {
    dependencies: ["Storage", "URL"],
    loggedIn: function(){
        return false;
    },
    token: async function(value){
        return isPresent(value) ? setToken() : getToken();

        async function getToken(){
            try {
                return await Plastic.Storage.get("PUM_TOKEN");
            }
            catch(e){return null}
        }
        async function setToken(){
            try {
                return await Plastic.Storage.set("PUM_TOKEN", value);
            }
            catch(e){}
        }
    }
}